import { useTranslation } from 'react-i18next';

import { AddContextMenu } from './AddContextMenu';
import {
    expenseAddButtonOrder,
    type ExpenseType,
    expenseTypeConfig,
} from '~/features/leadDetails/components/Overview/CustomerData/Expenses/expenseTypeConfig.ts';

type Props = {
    onAdd: (type: ExpenseType) => void;
};

export const AddExpense: React.FC<Props> = ({ onAdd }) => {
    const { t } = useTranslation();

    return (
        <AddContextMenu
            ariaLabel={t('EXPENSES.ADD')}
            getLabel={(type) => t(expenseTypeConfig[type].label)}
            itemTypes={expenseAddButtonOrder}
            onAdd={onAdd}
        />
    );
};
